import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DynamicResponse } from '../../models/general-models';
import { Right, Role } from '../../models/admin-models';

@Injectable()
export class RolesRightsService {
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  private http = inject(HttpClient);

  addRight(rightId, rightName, parentID): Observable<void> {
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Rights/Right/${rightId}/${rightName}/${parentID}`
    );
  }

  removeRight(rightId): Observable<void> {
    return this.rbs.deleteRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Rights/Right/${rightId}`
    );
  }

  editRight(rightId, name, parent): Observable<void> {
    const id = this.ss.get('session');
    const org = this.rbs.getOrg();

    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', id)
      .set('X-RB-I', 'pp')
      .set('X-RB-O', org)
      .set('Content-Type', 'text/plain');

    return this.rbs.patchRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Rights/Right/${rightId}/${name}/${parent}`,
      null,
      reqHeaders
    );
  }

  addRole(data): Observable<void> {
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Roles`,
      data
    );
  }

  editRole(data): Observable<void> {
    // return this.rbs.patchRequest<any>(
    //   `${this.rbs.baseUrl}/AppAdmin/Roles/Role/${roleId}/${roleName}`
    // );
    return this.rbs.postRequest<void>(
      `${this.rbs.baseUrl}/AppAdmin/Roles`,
      data
    );
  }

  removeRole(roleId): Observable<DynamicResponse<'result', boolean>> {
    return this.rbs.deleteRequest<DynamicResponse<'result', boolean>>(
      `${this.rbs.baseUrl}/AppAdmin/Roles/Role/${roleId}`
    );
  }

  addRoleRight(
    roleId,
    rightId
  ): Observable<DynamicResponse<'result', boolean>> {
    return this.rbs.postRequest<DynamicResponse<'result', boolean>>(
      `${this.rbs.baseUrl}/AppAdmin/Roles/Role/${roleId}/Rights/${rightId}`
    );
  }

  removeRoleRight(
    roleId,
    rightId
  ): Observable<DynamicResponse<'result', boolean>> {
    return this.rbs.deleteRequest<DynamicResponse<'result', boolean>>(
      `${this.rbs.baseUrl}/AppAdmin/Roles/Role/${roleId}/Rights/${rightId}`
    );
  }

  getRoles(): Observable<{ roles: Role[] }> {
    return this.rbs.getRequest<{ roles: Role[] }>(
      `${this.rbs.baseUrl}/AppAdmin/Roles/`
    );
  }

  getAllRights(): Observable<{ rights: Right[]; parentRight: Right[] }> {
    return this.rbs.getRequest<{ rights: Right[]; parentRight: Right[] }>(
      `${this.rbs.baseUrl}/AppAdmin/Rights/All`
    );
  }
}
